.componentWebsiteBlackFlowSteps {
  .union {
    margin-top: 64px;

    &.noDivide {
      margin-top: 0;
    }
  }
}